import * as i0 from '@angular/core';
import { Directive, forwardRef, Inject, NgModule } from '@angular/core';
import * as wjcCore from '@grapecity/wijmo';
import { NgbInputDatepicker } from '@ng-bootstrap/ng-bootstrap';
import * as i1 from '@bento/bento-ng';
import * as i2 from '@angular/cdk/bidi';

/* eslint-disable  @typescript-eslint/no-namespace */
/**
 * Actual wrapper declaration
 */
// export as part of input package
var wijmo;
(function (wijmo) {
    var input;
    (function (input) {
        'use strict';
        class BentoDropDownWrapper extends wjcCore.Control {
            /**
             * Initializes a new instance of the @see:DropDown class.
             */
            constructor(element, options, r) {
                // Calling the super class to initiate this Wijmo Control.
                // The CTA <=> Dropdown linkage does not work without initiating the element as
                // a `wijmo.Control` object
                super(element, null, false);
                /*
                 // Used for append-to-parent conponents
          
                 // ----======= Source Code from wijmo.ts =======----
                 var popup;
                 var ae = getActiveElement(),
                 popup = <any>Control.getControl(closest(ae, '.wj-control.wj-popup'));
                 if (popup && popup.owner && contains(this._e, popup.owner)) {
                 return true;
                 }
                 */
                // This popup control needs to be associated with its original parent HTMLElement
                // that is located in the Flexgrid cell element
                this.owner = options.owner;
                // starting from wijmo version >= 403, owner property needs to be updated,
                // like this
                element[wjcCore.Control._OWNR_KEY] = options.owner;
                // Add the two mandatory CSS classes to the popup element as a `wijmo.Control`
                r.addClass(element, 'wj-control');
                r.addClass(element, 'wj-popup');
                // Make sure this element is focusable
                if (element.getAttribute('tabindex') == null) {
                    r.setAttribute(element, 'tabindex', '-1');
                }
            }
        }
        input.BentoDropDownWrapper = BentoDropDownWrapper;
    })(input = wijmo.input || (wijmo.input = {}));
})(wijmo || (wijmo = {}));

/**
 * Main Bento Flexgrid Control Directive it only initiate register the HTMLElements that has [bentoAppendTo] directive
 */
class BentoComboboxFlexGridControlDirective {
    // Constructor
    constructor(elementRef, r) {
        this.r = r;
        this.el = elementRef.nativeElement;
    }
    ngAfterViewInit() {
        this.menuDir = this.el.querySelector('.bento-combobox-container');
        new wijmo.input.BentoDropDownWrapper(this.menuDir, { owner: this.el }, this.r);
    }
}
BentoComboboxFlexGridControlDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoComboboxFlexGridControlDirective, deps: [{ token: i0.ElementRef }, { token: i0.Renderer2 }], target: i0.ɵɵFactoryTarget.Directive });
BentoComboboxFlexGridControlDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "13.2.2", type: BentoComboboxFlexGridControlDirective, selector: "bento-combobox[bentoFlexGridControl]", ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoComboboxFlexGridControlDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: 'bento-combobox[bentoFlexGridControl]'
                }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }, { type: i0.Renderer2 }]; } });

/**
 * Main Bento Flexgrid Control Directive it only initiate register the HTMLElements that has [ngbDatepicker] directive
 */
class BentoDatepickerFlexGridControlDirective {
    // Constructor
    constructor(elementRef, r, window, inputDatepicker, bentoPositioning, dir) {
        this.r = r;
        this.window = window;
        this.inputDatepicker = inputDatepicker;
        this.bentoPositioning = bentoPositioning;
        this.dir = dir;
        this.el = elementRef.nativeElement;
        this.isRtl = dir.value === 'rtl';
        dir.change.subscribe(() => {
            this.flipDirection();
        });
    }
    ngAfterViewInit() {
        const appendToEl = this.findFlexGridEl() || this.window.nativeDocument.body;
        let side = 'bottom'; // default dropdown position
        // Hack: Remove Zone subscription
        this.inputDatepicker['_zoneSubscription'].unsubscribe();
        // Re-wire `inputDatepickeropen()`
        const open = this.inputDatepicker.open;
        this.inputDatepicker.open = () => {
            open.call(this.inputDatepicker);
            // HACK: `_cRef` is a private variable, BUT we need to wrap with Wijmo Control Wrapper
            const datepickerRef = this.inputDatepicker['_cRef'];
            const datepickerElRef = datepickerRef.location.nativeElement;
            const referenceElRect = appendToEl.getBoundingClientRect();
            const viewportHeight = Math.max(this.window.nativeDocument.documentElement.clientHeight, this.window.nativeWindow.innerHeight || 0);
            const bottom = viewportHeight - referenceElRect.bottom;
            if (bottom < this.el.offsetHeight && referenceElRect.top >= datepickerElRef.offsetHeight) {
                // Automatically invert side from bottom to top when there is not enough space under
                // the reference
                side = 'top';
            }
            new wijmo.input.BentoDropDownWrapper(datepickerElRef, { owner: this.el }, this.r);
            this.el.focus();
            this.r.addClass(datepickerElRef, 'bento-datepicker');
            this.r.appendChild(appendToEl, datepickerElRef);
            this.bentoPositioning.positionElement(this.r, this.el, datepickerElRef, appendToEl, side, this.isRtl ? 'right' : 'left');
            setTimeout(() => {
                // Move focus to the actual datepicker
                datepickerElRef.focus();
            }, 100);
        };
    }
    findFlexGridEl() {
        let el = this.el.parentElement;
        while (el && el.tagName !== 'BODY') {
            if (el.tagName === 'WJ-FLEX-GRID') {
                return el.parentElement;
            }
            el = el.parentElement;
        }
        return null;
    }
    flipDirection() {
        this.isRtl = this.dir.value === 'rtl';
    }
}
BentoDatepickerFlexGridControlDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoDatepickerFlexGridControlDirective, deps: [{ token: i0.ElementRef }, { token: i0.Renderer2 }, { token: i1.WindowRef }, { token: forwardRef(() => NgbInputDatepicker) }, { token: i1.BentoPositioning }, { token: i2.Directionality }], target: i0.ɵɵFactoryTarget.Directive });
BentoDatepickerFlexGridControlDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "13.2.2", type: BentoDatepickerFlexGridControlDirective, selector: "[ngbDatepicker][bentoFlexGridControl]", ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoDatepickerFlexGridControlDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[ngbDatepicker][bentoFlexGridControl]'
                }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }, { type: i0.Renderer2 }, { type: i1.WindowRef }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [forwardRef(() => NgbInputDatepicker)]
                }] }, { type: i1.BentoPositioning }, { type: i2.Directionality }]; } });

class BentoFlexGridControlModule {
}
BentoFlexGridControlModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoFlexGridControlModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
BentoFlexGridControlModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoFlexGridControlModule, declarations: [BentoComboboxFlexGridControlDirective, BentoDatepickerFlexGridControlDirective], exports: [BentoComboboxFlexGridControlDirective, BentoDatepickerFlexGridControlDirective] });
BentoFlexGridControlModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoFlexGridControlModule });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: BentoFlexGridControlModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [BentoComboboxFlexGridControlDirective, BentoDatepickerFlexGridControlDirective],
                    exports: [BentoComboboxFlexGridControlDirective, BentoDatepickerFlexGridControlDirective]
                }]
        }] });

/*
 * Public API Surface of bento-ng-flexgrid-control
 */

/**
 * Generated bundle index. Do not edit.
 */

export { BentoComboboxFlexGridControlDirective, BentoDatepickerFlexGridControlDirective, BentoFlexGridControlModule };
